/* LAVAZAPAS — extras: 3D con el raton, ciclo de lavado, galeria y selector de packs */
(function () {
  if (window.__cicloExtra) return;
  window.__cicloExtra = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- inclinacion 3D + brillo ---------- */
  function tilt() {
    if (reduce || !finePointer) return;
    var nodes = document.querySelectorAll('.cc-tilt:not([data-cc-tilt]), .cc-frame:not([data-cc-tilt])');
    Array.prototype.forEach.call(nodes, function (el) {
      el.setAttribute('data-cc-tilt', '1');
      var max = parseFloat(el.getAttribute('data-tilt') || '6');
      var rx = 0, ry = 0, raf = null;

      function apply() {
        raf = null;
        if (el.classList.contains('cc-rv') && !el.classList.contains('cc-in')) return;
        el.style.transform = 'perspective(1100px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
      }
      el.addEventListener('pointerenter', function () {
        el.style.transition = 'transform .12s linear';
      });
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var fx = (e.clientX - r.left) / r.width;
        var fy = (e.clientY - r.top) / r.height;
        el.style.setProperty('--gx', (fx * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (fy * 100).toFixed(1) + '%');
        rx = -(fy - 0.5) * max * 2;
        ry = (fx - 0.5) * max * 2;
        if (!raf) raf = requestAnimationFrame(apply);
      });
      el.addEventListener('pointerleave', function () {
        el.style.transition = 'transform .6s cubic-bezier(.2,.8,.3,1)';
        rx = 0; ry = 0;
        apply();
      });
    });
  }

  /* ---------- reiniciar el ciclo de lavado ---------- */
  function reset(wm) {
    if (!wm) return;
    var nodes = wm.querySelectorAll('.cc-suds, .cc-waterlevel, .cc-late');
    Array.prototype.forEach.call(nodes, function (el) {
      el.style.animation = 'none';
      el.getBoundingClientRect();
      el.style.animation = '';
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.cc-prog button') : null;
    if (!b || b.dataset.mode !== 'wash') return;
    var group = b.closest('.cc-prog');
    if (!group) return;
    reset(document.getElementById(group.getAttribute('data-target')));
  });

  /* ---------- galeria de la ficha ---------- */
  function gallery() {
    document.querySelectorAll('.cc-thumbs:not([data-cc-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-cc-bound', '1');
      var main = document.getElementById(wrap.getAttribute('data-main'));
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('.cc-thumb');
        if (!b || !main) return;
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = b.getAttribute('data-full');
          main.alt = b.getAttribute('data-alt') || main.alt;
          main.style.opacity = '1';
        }, 140);
        wrap.querySelectorAll('.cc-thumb').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- selector de packs ---------- */
  function packs() {
    document.querySelectorAll('.cc-packs:not([data-cc-bound])').forEach(function (group) {
      group.setAttribute('data-cc-bound', '1');
      var scope = group.closest('[data-cc-prod]') || document;
      var input = scope.querySelector('.cc-var-input');
      var price = scope.querySelector('.cc-total-price');
      var note = scope.querySelector('.cc-total-note');
      var btn = scope.querySelector('.cc-add-btn');

      function select(label) {
        group.querySelectorAll('.cc-pack').forEach(function (o) { o.classList.remove('is-on'); });
        label.classList.add('is-on');
        var r = label.querySelector('input');
        if (r) r.checked = true;
        if (input) input.value = label.getAttribute('data-id');
        if (price) price.textContent = label.getAttribute('data-price');
        if (note) note.textContent = label.getAttribute('data-note') || '';
        if (btn && label.getAttribute('data-available') === 'false') {
          btn.setAttribute('disabled', 'disabled');
        } else if (btn) {
          btn.removeAttribute('disabled');
        }
      }

      group.addEventListener('change', function (e) {
        var label = e.target.closest('.cc-pack');
        if (label) select(label);
      });
      group.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var label = e.target.closest('.cc-pack');
        if (!label) return;
        e.preventDefault();
        select(label);
      });
    });
  }

  function boot() { tilt(); gallery(); packs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
